// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pretitle{color:#e2001a;font-size:1rem;font-variation-settings:\"wght\" 400;font-weight:400;letter-spacing:.16688rem;margin-bottom:5px;text-transform:uppercase}@media (min-width:767px){.pretitle{font-size:1.125rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
